import type { ChangeContributionDataCommandData } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { LifeLazyForm } from '../forms/LifeLazyForm'
import { initialFormEntriesFromVBase } from '../forms/yup/validation/yupValidationUtils'
import { LifeInput } from '../inputs/LifeInput'

const validateKey =
  typeUtils.createValidator<ChangeContributionDataCommandData>()

export const ChangeContributionDataForm = (
  props: CommandDataFormProps<ChangeContributionDataCommandData>,
) => {
  const translate = useTranslate()

  const { tenantId, employerAgreementId } = useHook(
    'routing.employer.useEmployerAgreementParams',
  )()

  const fetchFrame = useHook(
    'lazyFetchers.life.useLazyFetchChangeContributionDataFrame',
  )({ tenantId, employerAgreementId })

  return (
    <LifeLazyForm
      mapInitialValues={(frame): ChangeContributionDataCommandData => ({
        _type: 'ChangeContributionDataCommandData',
        contributionData: {
          _type: 'ContributionData',
        },
        ...initialFormEntriesFromVBase(frame),
      })}
      fetchFrame={fetchFrame}
      {...props}
    >
      <LifeInput
        fallbackInputType="string"
        name={validateKey('applyDate')}
        label={translate('changeContributionData.input.applyDate')}
      />
      <LifeInput
        fallbackInputType="string"
        name={validateKey('contributionData.billingFrequency')}
        label={translate('changeContributionData.input.billingFrequency')}
      />
      <LifeInput
        fallbackInputType="boolean"
        name={validateKey('contributionData.paidInArreas')}
        label={translate('changeContributionData.input.paidInArrears')}
      />
    </LifeLazyForm>
  )
}
